// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationMetadata
 */
export interface NotificationMetadata {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NotificationMetadata
     */
    by_rule?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    dta_id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    file_name?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    proposal_id?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationMetadata
     */
    quarantined_count?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    review_status?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    run_id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    submission_id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    vendor_company?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    vendor_email?: string;
}

/**
 * Check if a given object implements the NotificationMetadata interface.
 */
export function instanceOfNotificationMetadata(value: object): value is NotificationMetadata {
    return true;
}

export function NotificationMetadataFromJSON(json: any): NotificationMetadata {
    return NotificationMetadataFromJSONTyped(json, false);
}

export function NotificationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'by_rule': json['by_rule'] == null ? undefined : json['by_rule'],
        'dta_id': json['dta_id'] == null ? undefined : json['dta_id'],
        'file_name': json['file_name'] == null ? undefined : json['file_name'],
        'proposal_id': json['proposal_id'] == null ? undefined : json['proposal_id'],
        'quarantined_count': json['quarantined_count'] == null ? undefined : json['quarantined_count'],
        'review_status': json['review_status'] == null ? undefined : json['review_status'],
        'run_id': json['run_id'] == null ? undefined : json['run_id'],
        'submission_id': json['submission_id'] == null ? undefined : json['submission_id'],
        'vendor_company': json['vendor_company'] == null ? undefined : json['vendor_company'],
        'vendor_email': json['vendor_email'] == null ? undefined : json['vendor_email'],
    };
}

export function NotificationMetadataToJSON(json: any): NotificationMetadata {
    return NotificationMetadataToJSONTyped(json, false);
}

export function NotificationMetadataToJSONTyped(value?: NotificationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'by_rule': value['by_rule'],
        'dta_id': value['dta_id'],
        'file_name': value['file_name'],
        'proposal_id': value['proposal_id'],
        'quarantined_count': value['quarantined_count'],
        'review_status': value['review_status'],
        'run_id': value['run_id'],
        'submission_id': value['submission_id'],
        'vendor_company': value['vendor_company'],
        'vendor_email': value['vendor_email'],
    };
}
